import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import {
  DbId,
  TPaneSign,
  TTreeId,
} from '../../../models/role-privs/RolePrivsData';
import { AppState } from '../../../store/reducers/root';
import { getPrivsTreeState } from '../../../store/selectors/rolePrivs';
import rolePrivs from '../../../store/slices/rolePrivs';

import PrivsTree from './PrivsTree';

interface IOwnTreeProps {
  className?: string;
  treeId: TTreeId;
  pane: TPaneSign;
  isCategoryTree?: boolean;
  onSelect?: (id: DbId) => void;
}

const mapStateToProps = (
  state: AppState,
  { className, treeId, pane, isCategoryTree }: IOwnTreeProps
) => ({
  className,
  tree: getPrivsTreeState(state, treeId),
  pane,
  isCategoryTree,
});

const mapDispatchToProps = {
  selectTreeNode: rolePrivs.selectTreeNode,
  nextTreeNode: rolePrivs.nextTreeNode,
  prevTreeNode: rolePrivs.prevTreeNode,
  expandTreeNode: rolePrivs.expandTreeNode,
  collapseTreeNode: rolePrivs.collapseTreeNode,
  toggleMainTreeNodeCheck: rolePrivs.toggleMainTreeNodeCheck,
  setCatalogAllPrivs: rolePrivs.setCatalogAllPrivs,
  setCategoryAllPrivs: rolePrivs.setCategoryAllPrivs,
  loadMainTreeRoot: rolePrivs.loadMainTreeRoot,
};

const mergeProps = (
  sP: ReturnType<typeof mapStateToProps>,
  {
    selectTreeNode,
    nextTreeNode,
    prevTreeNode,
    expandTreeNode,
    collapseTreeNode,
    toggleMainTreeNodeCheck,
    setCatalogAllPrivs,
    setCategoryAllPrivs,
    loadMainTreeRoot,
  }: typeof mapDispatchToProps,
  { treeId, pane, onSelect: onSelectProp, ...oP }: IOwnTreeProps
) => ({
  ...sP,
  ...oP,
  onSelect: (nodeId: DbId) => {
    onSelectProp?.(nodeId);
    selectTreeNode({ treeId, nodeId });
  },
  onNext: () => nextTreeNode({ treeId }),
  onPrev: () => prevTreeNode({ treeId }),
  onExpand: (nodeId?: DbId) => expandTreeNode({ treeId, nodeId }),
  onCollapse: (nodeId?: DbId) => collapseTreeNode({ treeId, nodeId }),
  onCheckToggle: (nodeId?: DbId) =>
    pane !== 'all' && toggleMainTreeNodeCheck({ treeId, pane, nodeId }),
  onGrantAllCatalogPrivs: (catalogId: DbId) =>
    setCatalogAllPrivs({ treeId, catalogId }),
  onGrantAllCategoryPrivs: (mainTreeActiveId: DbId) =>
    setCategoryAllPrivs({ treeId, mainTreeActiveId }),
  onRefresh: () =>
    pane !== 'all' && loadMainTreeRoot({ categoryTreeId: treeId, pane }),
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type TPrivsTreeConnectorProps = ConnectedProps<typeof connector>;

export default connector(PrivsTree);
